import { WidgetType } from 'types/widget.types';

import { IconWidgetCustomControl } from './controls/custom/IconWidgetCustomControl';
import { ImageWidgetCustomControl } from './controls/custom/ImageWidgetCustomControl';

export const WIDGET_CONTROL_COMPONENT_MAP: Partial<Record<WidgetType, React.FC>> = {
  [WidgetType.Image]: ImageWidgetCustomControl,
  [WidgetType.Icon]: IconWidgetCustomControl,
};
